import React, { useState, useEffect, useRef } from "react";
import { FiSettings, FiLogOut, FiChevronDown, FiInfo, FiActivity, FiSun, FiMoon } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { useTheme } from "./context/ThemeContext";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [pageTitle, setPageTitle] = useState("SOCIETY MANAGER");
  const { theme, toggleTheme } = useTheme();

  const location = useLocation();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const pathTitleMap = {
      "/CreateSociety": "SOCIETY PROFILE",
      "/SocietyList": "SOCIETY LIST",
      "/CreateSocietyAdmin": "NEW ADMINISTRATOR",
      "/CreateSocietyAdminList": "ADMINISTRATOR LOG",
      "/all-admin-login": "SYSTEM ACCESS LOGS",
      "/AddSocietyAdmin": "EDIT ADMINISTRATOR",
      "/user-query": "User Query",
      "/request-demo": "Society Demo Request",

    };
    // Extract base path for dynamic routes if needed, or exact match
    const title = pathTitleMap[location.pathname] || "DASHBOARD";
    setPageTitle(title);
  }, [location]);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex justify-between items-center py-6 px-8 bg-bg-secondary/50 backdrop-blur-md border-b border-border text-text-main relative z-40 transition-colors duration-300">

      {/* Page Title */}
      <div className="flex items-center gap-4">
        <h2 className="text-2xl font-clash font-bold text-text-main tracking-wide uppercase transition-colors">

          {pageTitle}
        </h2>
        <div className="h-6 w-[1px] bg-border hidden md:block"></div>

        {/* <div className="hidden md:flex items-center gap-2 text-xs font-mono text-signal-lime">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-signal-lime opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-signal-lime"></span>
          </span>
          LIVE
        </div> */}
      </div>

      {/* User Actions */}
      <div className="flex items-center gap-4 relative" ref={dropdownRef}>
        <button
          onClick={toggleTheme}
          className="p-2 rounded border border-border hover:bg-bg-tertiary transition-colors text-text-main hover:text-signal-orange"

          title="Toggle Theme"
        >
          {theme === 'dark' ? <FiMoon /> : <FiSun />}
        </button>

        <div className="hidden md:flex flex-col items-end mr-2">
          <span className="text-sm font-bold font-clash text-text-main tracking-wide">
            SUPER ADMIN
          </span>
          {/* <span className="text-[10px] uppercase tracking-wider text-text-muted">Access Level: 01</span> */}
        </div>

        <button
          onClick={toggleMenu}
          className={`flex items-center gap-2 p-2 rounded border transition-all duration-300 ${menuOpen
            ? 'bg-signal-orange text-noir-900 border-signal-orange'
            : 'bg-bg-secondary text-text-main border-border hover:border-text-muted'
            }
`}
        >
          <FiSettings className="text-lg" />
          <FiChevronDown className={`transition-transform duration-300 ${menuOpen ? "rotate-180" : ""}`} />
        </button>

        {/* Dropdown */}
        <div className={`absolute top-full right-0 mt-2 w-56 bg-bg-secondary border border-border shadow-md rounded-sm overflow-hidden transition-all duration-200 origin-top-right ${menuOpen ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 -translate-y-2 pointer-events-none'}`}>
          <div className="p-1">
            <button onClick={() => alert("Settings")} className="flex items-center gap-3 w-full p-3 text-sm text-text-muted hover:text-text-main hover:bg-bg-tertiary transition-colors text-left group">
              <FiSettings className="group-hover:text-signal-orange transition-colors" /> Settings
            </button>
            <button onClick={() => alert("Info")} className="flex items-center gap-3 w-full p-3 text-sm text-text-muted hover:text-text-main hover:bg-bg-tertiary transition-colors text-left group">
              <FiInfo className="group-hover:text-signal-orange transition-colors" /> System Info
            </button>
            <div className="h-[1px] bg-border my-1"></div>
            <button onClick={handleLogout} className="flex items-center gap-3 w-full p-3 text-sm text-red-500 hover:bg-bg-tertiary transition-colors text-left font-medium">
              <FiLogOut /> Disconnect
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
